import React from 'react';
import FilterGroupNew from '../search/filterGroupNew';

interface FilterCategory {
  key: string;
  category: string;
  label: string;
}

interface FilterContentProps {
  selectedTabFilter?: string;
  filtersToApply: Record<string, any>;
  filterCategoryValueMap: Record<string, any>;
  filterCategoryMap: FilterCategory[];
  filterDataMap: Record<string, any>;
  onChangeFilter: (e: React.MouseEvent<HTMLImageElement>) => void;
}

const FilterContent: React.FC<FilterContentProps> = ({
  selectedTabFilter = '',
  filtersToApply,
  filterCategoryValueMap,
  filterCategoryMap,
  filterDataMap,
  onChangeFilter,
}) => {
  const excludeFilter = [
    'issuingAuthority',
    'categoryFilter.categoryFilterValue',
  ];

  let visibleCategories;
  if (selectedTabFilter === 'category') {
    visibleCategories = filterCategoryMap.filter(
      (f) => !excludeFilter.includes(f.key)
    );
  } else if (selectedTabFilter) {
    visibleCategories = filterCategoryMap.filter(
      (f) => f.key === selectedTabFilter && !excludeFilter.includes(f.key)
    );
  } else {
    visibleCategories = filterCategoryMap.filter(
      (f) => !excludeFilter.includes(f.key)
    );
  }

  if (!visibleCategories.length) {
    return (
      <div className="lil-shadow-sm lil-px-6 lil-py-2 lil-mt-3">
        <div className="lil-p-4">
          No filters available for the selected category
        </div>
      </div>
    );
  }

  const getDisplayText = (category: string, value: string) => {
    if (category === 'fundMetaData.exitLoad.percentage') {
      if (value === '0') {
        return 'No Exit Load';
      } else if (value === '-0') {
        return 'With Exit Load';
      }
      return value;
    } else if (category === 'fundType') {
      if (value === 'ELSS') {
        return 'Tax Savings';
      } else if (value === 'Metals') {
        return 'Commodities';
      }
      return value;
    } else if (category === 'fundMetaData.morningStarRating') {
      return value + ' Star';
    }
    return value;
  };

  return (
    <div className="lil-shadow-sm lil-px-6 lil-py-2 lil-mt-3">
      <div className="lil-flex lil-gap-2 lil-flex-wrap lil-pb-4">
        {visibleCategories.map(({ category }) =>
          (filterCategoryValueMap[category] || []).map(
            (text: string, index: number) => (
              <div
                key={`${category}-${index}`}
                className="lil-border-sm lil-border-blue-300 lil-w-auto lil-rounded-xxl lil-text-blue-300 lil-px-2 lil-py-1 lil-flex"
              >
                {getDisplayText(category, text)}
                <img
                  src="http://cleartax-media.s3.amazonaws.com/cleartax/images/1742905195_closebutton.svg"
                  alt="close"
                  data-attr={text}
                  data-category={category}
                  onClick={onChangeFilter}
                  className="lil-pl-2"
                />
              </div>
            )
          )
        )}
      </div>
      {visibleCategories.map((category) => {
        const filters = filterDataMap[category.category];
        return (
          <FilterGroupNew
            filterCategoryValueMap={filtersToApply || filterCategoryValueMap}
            filters={filters}
            onCheckboxClick={onChangeFilter}
            showSubFilter={false}
            category={category.category}
            key={category.label}
            filterName={category.label}
          />
        );
      })}
    </div>
  );
};

export default FilterContent;



// WEBPACK FOOTER //
// ./components/amcNew/FilterContent.tsx